
















import Vue from 'vue'
import { DashboardMessage } from '@/model/dashboard/DashboardMessage'

interface ComponentData {}

export default Vue.extend({
  name: 'Messages',

  props: {
    messagesLabel: String,
    messagesData: {
      type: Array as () => Array<DashboardMessage>
    },
    isMessagesData: Boolean
  },

  data (): ComponentData {
    return {}
  },

})
